import type { Dir, Lang } from '@/i18n/config'

import { useRouter } from 'next/router'
import { toDir, toLang } from '@/i18n/config'

export type Dict<T> = {
    ar: T
    en: T
}

export type LangInfo = {
    lang: Lang
    dir: Dir
    isRtl: boolean
}

export const useLang = (): LangInfo => {
    const { locale } = useRouter()
    const lang = toLang(locale)
    const dir = toDir(lang)

    return { lang, dir, isRtl: dir === 'rtl' }
}

/**
 * Picks the active language from a { ar, en } dictionary.
 * Every feature keeps its own dictionary file in src/i18n.
 */
export const useT = <T,>(dict: Dict<T>): T => {
    const { lang } = useLang()
    return dict[lang]
}

export const defineDict = <T,>(ar: T, en: T): Dict<T> => ({ ar, en })
